var map = {
	"./avatar_0.jpg": "4cd1",
	"./avatar_1.jpg": "7d7a",
	"./avatar_2.jpg": "e949",
	"./avatar_3.jpg": "f9b1",
	"./avatar_4.jpg": "8c71",
	"./avatar_5.jpg": "9ed21",
	"./avatar_6.jpg": "46dc",
	"./avatar_7.jpg": "c64f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f869";